import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "overflow-auto q-mb-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_deslizar_movil = _resolveComponent("deslizar-movil");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", {
                class: _normalizeClass(_ctx.estilos)
            }, [
                _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configuracionColumnas, (columna, index) => {
                            return (_openBlock(), _createElementBlock("th", {
                                key: index,
                                class: _normalizeClass(["text-left", { 'mini-texto': _ctx.dense }])
                            }, _toDisplayString(columna.label), 3));
                        }), 128))
                    ])
                ]),
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementos, (fila, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fila, (celda, index) => {
                                return (_openBlock(), _createElementBlock("td", {
                                    key: index,
                                    class: _normalizeClass(["text-no-wrap", { 'mini-texto': _ctx.dense }])
                                }, _toDisplayString(celda), 3));
                            }), 128))
                        ]));
                    }), 128))
                ])
            ], 2)
        ]),
        _createVNode(_component_deslizar_movil)
    ], 64));
}
